import type { ComponentType } from "react";

import type { IDenovoIconComponentProps } from "../interfaces";

import { AppLogoMobile } from "./AppLogoMobile";
import { BondSingle } from "./BondSingle";
import { Chain } from "./Chain";
import { LinkedIn } from "./LinkedIn";
import { MoleculeLoader } from "./MoleculeLoader";
import { SortAscending } from "./SortAscending";
import { SortDescending } from "./SortDescending";

export const CUSTOM_ICON_COMPONENTS: Record<
  string,
  ComponentType<IDenovoIconComponentProps>
> = {
  "app-logo-mobile": AppLogoMobile,
  "molecule-loader": MoleculeLoader,
  linkedin: LinkedIn,
  "bond-single": BondSingle,
  chain: Chain,
  "sort-asc": SortAscending,
  "sort-desc": SortDescending,
};
